import { render, staticRenderFns } from "./RegisterConfirmation.vue?vue&type=template&id=c08be5ea&scoped=true"
import script from "./RegisterConfirmation.vue?vue&type=script&lang=js"
export * from "./RegisterConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08be5ea",
  null
  
)

export default component.exports